export const INIT_FORM = {
    requestId: "",
    meetingId: "",
    campusDetailId: 0, environmentTypeId: "",
    quantityVacancy: "", date: -1,
    timeStart: -1, timeEnd: -1,
    environment: {
        id: "", environmentCode: "", floor: "",
        capacity: "", address: ""
    }
};
export const MOCK_FORM = {
    requestId: "00000148",
    meetingId: "1",
    campusDetailId: 6, environmentTypeId: "ATEO",
    quantityVacancy: "30", date: 1682398800000,
    timeStart: 945, timeEnd: 975,
    environment: {
        id: "09A0301", environmentCode: "A0301", floor: "03",
        capacity: "90", address: "Av. Petit Thouars 116"
    }
};